<template>
	<Modal
		:mask-closable="false"
		width="360"
		class="verify"
		:closable="false"
		v-model="show">
		<template v-if="verifyType === 'msg'">
			<div slot="header" class="verify-title">
				<span @click="getFaceImgCode">扫脸认证</span>
				<span class="active">短信验证</span>
			</div>
			<div class="verify-item">
				<div class="verify-item-label">手机号码：</div>
				<div class="verify-item-cont">
					<Input v-model="sjhm" disabled/>
				</div>
			</div>
			<div class="verify-item">
				<div class="verify-item-label">验证码：</div>
				<div class="verify-item-cont">
					<Input v-model="yzm">
						<Button type="primary" v-if="code.sec === 0" @click="sendCode" slot="append">发送验证码</Button>
						<Button type="primary" v-else disabled slot="append">{{ code.sec }}秒后重新发送</Button>
					</Input>
				</div>
			</div>
			<div slot="footer" >
				<div class="verify-footer-tip">温馨提示：联通客户请使用人脸识别认证。</div>
				<div class="verify-footer">
					<Button @click="cancel">取 消</Button>
					<Button type="primary" @click="codeCheck">确 定</Button>
				</div>
			</div>
		</template>
		<template v-else-if="verifyType === 'face'">
			<div slot="header" class="verify-title">
				<span class="active">扫脸认证</span>
				<span @click="closeFace">短信验证</span>
			</div>
			<div class="verify-face">
				<div class="verify-face-cont" v-if="!face.success">
					<div class="verify-face-cont-tit">打开手机支付宝，扫描二维码开始刷脸认证</div>
					<img ref="faceimg">
					<div class="verify-face-cont-info">
                    <span v-show="face.time > 40">
                        二维码已过期，请点击
                        <a @click="getFaceImgCode">刷新</a>
                    </span>
					</div>
				</div>
				<div class="verify-face-suc" v-else>
					<Icon type="checkmark-circled" size="170" color='#19be6b'></Icon>
					<div>认证成功！</div>
				</div>
				
				<!--加载中-->
				<Spin size="large" fix v-if="face.loading"></Spin>
			</div>
			
			
			<div slot="footer" class="verify-footer">
				<Button :loading='face.loading' @click="cancel">{{ face.loading ? '查询中' : '取消' }}</Button>
			</div>
		</template>
	</Modal>
</template>

<script type="text/ecmascript-6">
import QRCode from 'qrious'

export default {
	name: 'VerifyId',
	props: {
		//model显示隐藏属性
		modelShow: false,
		type: 'com',
		userName: '',
		idNum: '',
		sjhm: '',
	},
	data () {
		return {
			show: false,
			verifyType: 'msg',
			yzm: '',
			code: {
				sec: 0,
			},
			face: {
				success: false,
				// 二维码过期时间
				time: 0,
				// 二维码地址
				data: null,
				// 加载效果
				loading: false
			},
			authType: null,// 1、短信验证码2、刷脸
			// 加载中
			loading: false,
		}
	},
	watch: {
		//监听器，监听控件显示隐藏
		modelShow: function (val) {
			// 打开时
			if (val) {
				// 打开刷脸
				this.getFaceImgCode()
				// 清空验证码
				this.yzm = ''
			}
			this.show = val
		}
	},
	mounted () {
	},
	methods: {
		/**
		 * 关闭刷脸
		 */
		closeFace () {
			this.verifyType = 'msg'
			clearInterval(this.face.lunxun)
		},
		/**
		 * 获取刷脸地址
		 */
		async getFaceImgCode () {
			this.verifyType = 'face'
			let { userName, idNum } = this
			
			this.face.loading = true
			const { data } = await this.$http.post('/ej-isp-api/alipay/auth-url', {
				userName,
				idNum,
				returnPage: '11'
			})
			this.face.loading = false
			if (data.code === '0000000') {
				const { url, biz_no } = data.body
				this.face.data = biz_no
				const dm = this.$refs.faceimg
				this.face.time = 0
				// 生成二维码
				new QRCode({
					value: url,
					element: dm,
					size: 200
				})
				// 通过轮训的方式查询状态
				if (this.face.lunxun) {
					clearInterval(this.face.lunxun)
				}
				if(this.verifyType === 'face'){
					
					this.face.lunxun = setInterval(async () => {
						this.face.time += 1
						if (this.face.time > 40) {
							clearInterval(this.face.lunxun)
						} else {
							await this.getSearchFace()
						}
					}, 3000)
				}
			}
		},
		/**
		 * 查询刷脸结果
		 * @returns {Promise<void>}
		 */
		async getSearchFace () {
			const bizNo = this.face.data
			if (!bizNo) {
				return false
			}
			try {
				const res = await this.$http.post(
					'/ej-isp-api/alipay/brushFaceCheck', {
						bizNo
					}
				)
				// 认证成功
				if (res.data.success) {
					if (this.face.lunxun) {
						clearInterval(this.face.lunxun)
					}
					this.face.success = true
					this.face.loading = true
					setTimeout(() => {
						this.face.show = false
						this.face.loading = false
						this.verifyType = 'msg'
						// 验证方式赋值
						this.authType = 2
						this.yzm = ''
						// 验证通过
						this.excute()
						
						this.face.success = false
					}, 500)
				}
			} catch (e) {
				console.error(e)
			}
		},
		/**
		 * 发送验证码
		 */
		sendCode () {
			this.$http.post('/ej-isp-api/sms/send-code', { mobile: this.sjhm, })
				.then(res => {
					if (res.data.code === '0000000') {
						this.sendDown()
						this.$Notice.success({
							desc: '短信发送成功'
						})
					} else {
						throw false
					}
				})
				.catch(res => {
					this.$Notice.warning({
						desc: '短信发送失败,重发或采用刷脸认证'
					})
				})
		},
		/**
		 * 短信验证码发送成功
		 */
		sendDown () {
			const TIME_COUNT = 60
			if (!this.timer) {
				this.code.sec = TIME_COUNT
				this.timer = setInterval(() => {
					if (this.code.sec > 0 && this.code.sec <= TIME_COUNT) {
						this.code.sec--
					} else {
						clearInterval(this.timer)
						this.timer = null
					}
				}, 1000)
			}
		},
		/**
		 * 校验验证码是否正确
		 */
		codeCheck () {
			let _this = this
			this.$http.post('/ej-isp-api/sms/auth-code', {
					mobile: this.sjhm,
					smsCode: this.yzm
				})
				.then(res => {
					if (res.data.code === '0000000') {
						// 验证方式赋值
						this.authType = 1
						try {
							// 验证通过
							_this.excute()
						} catch (e) {
						
						}
					} else {
						throw false
					}
				})
				.catch(res => {
					this.$Notice.warning({
						desc: '验证码错误'
					})
				})
		},
		cancel () {
			this.closeFace()
			this.$emit('cancel')
		},
		/**
		 * 父子组件交互
		 */
		excute () {
			console.log('请在父类中继承改方法')
		},
		/**
		 * 返回验证数据
		 * @returns {{bizNo: default.methods.bizNo, smsCode: default.methods.smsCode, authType: default.methods.authType}}
		 */
		getAuthData () {
			const {
				authType,
				yzm: smsCode,
				face: {
					data: bizNo
				},
				userName,
				idNum
			} = this;
			
			const operateName = userName;
			const operateId = idNum;
			return {
				authType,
				smsCode,
				bizNo,
				userName,
				idNum,
				operateName,
				operateId,
			}
		}
	}
}
</script>

<style lang="scss">
.verify {
	&-title {
		.active {
			font-size: 20px;
			color: #2d8cf0;
		}
		
		span {
			font-size: 18px;
			cursor: pointer;
			margin-right: 25px;
		}
	}
	
	&-item {
		
		$height: 40px;
		display: flex;
		height: $height;
		justify-content: flex-start;
		
		&-label {
			width: 60px;
			line-height: $height;
			flex-shrink: 0;
			flex-grow: 0;
		}
		
		&-cont {
			flex-shrink: 1;
			flex-grow: 1;
			display: flex;
			height: 100%;
			width: 100%;
			justify-content: center;
			align-items: center;
		}
	}
	
	&-face {
		position: relative;
		
		&-cont {
			width: 100%;
			display: flex;
			justify-content: center;
			flex-wrap: wrap;
			
			&-tit {
				width: 100%;
				text-align: center;
			}
			
			&-info {
				width: 100%;
				text-align: center;
			}
			
		}
		
		&-suc {
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
		}
		
	}
	
	&-footer {
		width: 100%;
		height: 40px;
		display: flex;
		justify-content: flex-end;
		align-items: center;
		
		&-tip {
			text-align: left;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/VerifyId/VerifyId.vue